import '@styles/pages/homepage.scss';
import { initCarousel } from '@organisms/carousel';
import { initOfferCard } from '@organisms/offer-card';

import { flickitySliderBySelector } from '@organisms/flickity-continuous-slider';
import { initSelectionBusHandler } from '@organisms/selection-bus-handler';
import { selectionSliderManager } from '@organisms/selection-slider-manager';
import { stickyCta } from '@organisms/sticky-cta';
import 'lite-youtube-embed';
import { renderHomeLastSearch } from '@organisms/home-last-search';

stickyCta('.home-sticky', '.home-hero__ctas', 'home-sticky');
flickitySliderBySelector('.home-components-customers');
initCarousel();
initOfferCard();
initSelectionBusHandler();
selectionSliderManager();
renderHomeLastSearch();
